import moment from 'moment'

export const DashboardSubmittedPayrollContainerComponent = {
    template: `
        <apex-dashboard-submitted-payrolls ng-if="$ctrl.loaded && $ctrl.page.Entities.length"
                                           page="$ctrl.page"
                                           on-dismiss="$ctrl.onDismiss($event)"
                                           on-change-page="$ctrl.onChangePage($event)">
        </apex-dashboard-submitted-payrolls>`,
    require: {
        dashboardContext: "?^apexDashboardContent"
    },
    controller: class DashboardSubmittedPayrollContainer {
        constructor(payrollService, utilityService) {
            'ngInject'
            this.payrollService = payrollService
            this.utilityService = utilityService
            this.pageIndex = 0
            this.pageSize = 10
            this.filters = {
                // Don't load more than the last 2 weeks of submitted payrolls
                start: moment().add(-2, "weeks").toDate(),
                locked: true,
                completed: false,
                sort: ['StartDateDesc', 'Owner'],
                dismissed: false
            }
            this.loaded = false
        }

        $onInit() {
            this.payrollService.retrievePayrollsPage(this.filters, this.pageIndex, this.pageSize)
                .then(page => {
                    this.page = page
                    this.loaded = true

                    if (this.dashboardContext) {
                        this.dashboardContext.activateDashboard({
                            visible: this.page.TotalEntityCount > 0,
                            count: this.page.TotalEntityCount
                        })
                    }
                })
        }

        onDismiss({ payroll }) {
            payroll.IsDismissed = true
            const saving = this.payrollService.dismissPayrollSubmittedMessage(payroll.PayrollID)

            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(saving, "Dismissal failed"))
        }

        onChangePage({ pageIndex }) {
            this.pageIndex = pageIndex

            const loading = this.payrollService.retrievePayrollsPage(this.filters, this.pageIndex, this.pageSize)
                .then(page => this.page = page)

            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(loading, "Changing page failed")
            )
        }
    }
}
